import Game from "../../../src/Game";
import ComponentManager from "./game/managers/ComponentManager";
import { INFO_SLIDER_ASSETS_SLUG } from "./game/types/Config";

const canvas = document.querySelector("#canvas") as HTMLCanvasElement;

if (canvas) {
  (window as any).context = new Game(canvas, INFO_SLIDER_ASSETS_SLUG, () => new ComponentManager());
} else {
  console.error("Canvas is not found");
}
